import React from 'react';
import { Box, createStyles, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BlockReleaseLegend } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/BlockReleaseLegend/BlockReleaseLegend';
import MainPageLayoutContainer from '@components/MainPageLayout/presentationalComponents/MainPageLayoutContainer';
import MainPageLayoutHeader from '@components/MainPageLayout/presentationalComponents/MainPageLayoutHeader';
import MainPageLayoutSubsection from '@components/MainPageLayout/presentationalComponents/MainPageLayoutSubsection';
import MainPageLayoutBody from '@components/MainPageLayout/presentationalComponents/MainPageLayoutBody';
import { BLOCK_RELEASE_MAX_HEIGHT, X_LARGE_MAX_WIDTH } from '@theme/themeConstants';
import { ReleasesSection } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/ReleasesSection/ReleasesSection';
import { BlockReleaseRequestProvider } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';
import { AuthenticatedBanner } from '@components/AuthenticatedBanner/AuthenticatedBanner';
import { ModalContextProvider } from '@components/Modal/ModalContextProvider';
import {
	BlockInfoSection
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/BlockInfoSection/BlockInfoSection';

const useStyles = makeStyles((theme) =>
	createStyles({
		banner: {
			margin: theme.spacing(0),
		},
		bodyClass: {
			'backgroundColor': theme.palette.common.white,
			'& > div:first-child': {
				'maxWidth': '1022px',
				[theme.breakpoints.up('xl')]: {
					maxWidth: X_LARGE_MAX_WIDTH,
				},
				'& [data-field="component-container"]': {
					display: 'flex',
					maxHeight: 'fit-content',
				},
			},
		},
		header: {
			justifyContent: 'flex-end',
		},
		headerSubSection: {
			flexDirection: 'column',
			padding: theme.spacing(0, 0, 4, 0),
		},
		pageBody: {
			display: 'grid',
			gridTemplateColumns: 'minmax(200px, 292px) minmax(548px, 1fr)',
			gridTemplateAreas: `"releases blockInfoSection"`,
			gap: theme.spacing(4),
			maxHeight: BLOCK_RELEASE_MAX_HEIGHT,
		}
	}),
);
export const BlockReleaseRequestPage = () => {
	const classes = useStyles();

	return (
		<ModalContextProvider>
			<BlockReleaseRequestProvider>
				<MainPageLayoutContainer
					pageName="BlockReleaseRequestPage"
					bodyClass={classes.bodyClass}
				>
					<MainPageLayoutHeader className={classes.header}>
						<MainPageLayoutSubsection className={classes.headerSubSection}>
							<Box className={classes.banner}>
								<AuthenticatedBanner />
							</Box>
							<BlockReleaseLegend />
							<Divider orientation="horizontal" />
						</MainPageLayoutSubsection>
					</MainPageLayoutHeader>
					<MainPageLayoutBody className={classes.pageBody}>
						<ReleasesSection />
						<BlockInfoSection />
					</MainPageLayoutBody>
				</MainPageLayoutContainer>
			</BlockReleaseRequestProvider>
		</ModalContextProvider>
	);
};
